import { useState } from 'react';

import { Box } from '@mui/system';

import { SkopeiPoster, SkopeiClip } from '~assets/video';

const LoginSplash = () => {
	const [ready, setReady] = useState(false);

	return (
		<Box sx={{ position: 'relative', height: '100%', width: '100%' }}>
			<video
				src={SkopeiClip}
				poster={SkopeiPoster}
				autoPlay
				muted
				loop
				playsInline
				controls={false}
				preload='metadata'
				onCanPlay={() => setReady(true)}
				style={{
					inset: 0,
					width: '100%',
					height: '100%',
					objectFit: 'cover',
					display: 'block',
					opacity: ready ? 1 : 0,
					transition: 'opacity 500ms ease',
				}}
			/>
			<Box
				sx={{
					height: '100%',
					width: '100%',
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					background: 'black',
					opacity: 0.3,
					position: 'absolute',
				}}
			/>
		</Box>
	);
};

export default LoginSplash;
